import { render, staticRenderFns } from "./changePrices.vue?vue&type=template&id=7af61304&scoped=true&"
import script from "./changePrices.vue?vue&type=script&lang=js&"
export * from "./changePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af61304",
  null
  
)

export default component.exports